import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";

const Technologygcc = () => {
  return (
    <div className="tekrevol_gray_bg tabing_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">Technologies We Use</h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              We leverage advanced tech for cross-platform mobile application
              development to drive you toward your objectives seamlessly.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Frameworks">
              <ul>
                <li>React Native</li>
                <li>Xamarin</li>
                <li>Ionic</li>
                <li>Cordova</li>
                <li> Flutter</li>
                <li> React Native</li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Cloud">
              <ul>
                <li>AWS</li>
                <li>Microsoft Azure</li>
                <li>Google Cloud Platform</li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Frontend">
              <ul>
                <li>ReactJS</li>
                <li>Vue.js</li>
                <li>Bootstrap</li>
                <li>AngularJS</li>
                <li>JQuery</li>
                <li>WPF</li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Backend & Database">
              <ul>
                <li>Laravel</li>
                <li>Django</li>
                <li>Flask</li>
                <li> MySQL</li>
                <li>SQL Server</li>
                <li>MariaDB</li>
                <li>MongoDB</li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Others">
              <ul>
                <li>Android Studio</li>
                <li>Visual Studio</li>
                <li>NetBeans</li>
                <li>AWS</li>
                <li>Docker</li>
                <li>Azure</li>
                <li>Google Cloud</li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
